/**
 * Agrupamento de eventos relacionados (checkout, journey, funnel).
 */

import type { SendEventParams } from '../../utils/sendEvent';
import type { QueueItem } from '../queue';

export interface TransactionGroupFields {
  transaction_id?: string;
  journey_id?: string;
  funnel_id?: string;
}

export function extractTransactionGroup(
  eventData: SendEventParams['eventData']
): TransactionGroupFields {
  if (!eventData || typeof eventData !== 'object') return {};
  const d = eventData as Record<string, unknown>;
  return {
    transaction_id:
      (d.transaction_id as string) ??
      (d.transactionId as string) ??
      undefined,
    journey_id: d.journey_id as string | undefined,
    funnel_id: d.funnel_id as string | undefined,
  };
}

export function enrichEventDataWithGroup(
  eventData: SendEventParams['eventData'],
  group?: TransactionGroupFields
): SendEventParams['eventData'] {
  const base =
    eventData && typeof eventData === 'object'
      ? { ...(eventData as Record<string, unknown>) }
      : {};
  if (group?.transaction_id && !base.transaction_id) {
    base.transaction_id = group.transaction_id;
  }
  if (group?.journey_id && !base.journey_id) {
    base.journey_id = group.journey_id;
  }
  if (group?.funnel_id && !base.funnel_id) {
    base.funnel_id = group.funnel_id;
  }
  return base as SendEventParams['eventData'];
}

/** Não mistura grupos críticos diferentes no mesmo batch. */
export function getTransactionGroupKey(item: QueueItem): string {
  const g = extractTransactionGroup(item.params.eventData);
  if (g.transaction_id) return `txn:${g.transaction_id}`;
  if (g.journey_id) return `journey:${g.journey_id}`;
  return 'default';
}

export function canBatchTogether(a: QueueItem, b: QueueItem): boolean {
  if (a.type !== 'conversion' && b.type !== 'conversion') return true;
  return getTransactionGroupKey(a) === getTransactionGroupKey(b);
}
